import React, { useEffect, useState } from 'react';

import GridItem from 'components/Grid/GridItem.js';
import GridContainer from 'components/Grid/GridContainer.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import { Assignment, Search } from '@material-ui/icons';
import { FormControl, InputLabel, MenuItem, Select, TextField, InputAdornment } from '@material-ui/core';
import ModalFilterArticle from 'components/Tvendo/Common/ModalFilterArticle';
import { wsFindBy, wsGetAll } from 'services/WService';

const articleTypes = [
  { value: 'L', description: 'Artículo' },
  { value: 'I', description: 'Trabajo' },
  { value: 'T', description: 'Viaje' },
  { value: 'F', description: 'Activo fijo' },
];

export default function WriteResume(props) {
  const { inputChange, dataProduct, setDataProduct } = props; //data Products

  // #region listados
  const [categories, setCategories] = useState([]);
  const [lines, setLines] = useState([]);
  const [families, setFamilies] = useState([]);
  const [subfamilies, setSubFamilies] = useState([]);
  const [marks, settMarks] = useState([]);
  const [itemGroups, setItemGroups] = useState([]);
  const [measureUnitTypes, setMeasureUnitTypes] = useState([]);
  const [priceLists, setPriceLists] = useState([]);
  const [providers, setProviders] = useState([]);
  const [openModalProduct, setOpenModalProduct] = useState(false);
  const [ProductSelect, setProductSelect] = useState(undefined);

  async function listCategories() {
    let response = await wsFindBy(
      'logi/category',
      'base_business_partner_id',
      dataProduct.base_business_partner_id,
    );
    if (response.success) setCategories(response.data);
  }

  async function listLines() {
    let response = await wsFindBy('logi/line', 'logi_category_id', dataProduct.logi_category_id);
    if (response.success) setLines(response.data);
  }

  async function listFamilies() {
    let response = await wsFindBy('logi/family', 'logi_line_id', dataProduct.logi_line_id);
    if (response.success) setFamilies(response.data);
  }

  async function listSubFamilies() {
    let response = await wsFindBy('logi/sub-family', 'logi_family_id', dataProduct.logi_family_id);
    if (response.success) setSubFamilies(response.data);
  }

  async function listMarks() {
    let response = await wsGetAll('logi/mark');
    if (response.success) settMarks(response.data);
  }

  async function listProductGroups() {
    let response = await wsGetAll('logi/product-group');
    if (response.success) setItemGroups(response.data);
  }

  async function listMeasureUnitTypes() {
    let response = await wsGetAll('logi/measure-unit');
    if (response.success) setMeasureUnitTypes(response.data);
  }

  async function listPrices() {
    let response = await wsGetAll('logi/price-list');
    if (response.success) setPriceLists(response.data);
  }

  async function listProviders() {
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) setProviders(response.data);
  }
  // #endregion

  useEffect(() => {
    listCategories();
    listLines();
    listFamilies();
    listSubFamilies();
    listMarks();
    listProductGroups();
    listMeasureUnitTypes();
    listPrices();
    listProviders();
  }, []);
  
  useEffect(() => {
    if (ProductSelect) {
      setDataProduct(prev => ({
        ...prev,
        logi_product_origin_id: ProductSelect.id,
        logi_product_origin_name: `${ProductSelect.ItemName} (${ProductSelect.ItemCode})`
      }));
    }
  }, [ProductSelect, setDataProduct]);
  return (
    <>
      <GridItem xs={12} sm={12} md={4}>
        <ModalFilterArticle
          open={openModalProduct}
          setOpen={setOpenModalProduct}
          entity={`logi/product`}
          setProductSelect={setProductSelect}
          filterCustom={{
            QryGroup1:'N',
            // QryGroup1:'Y',
            // frozenFor:'N',
          }}
        />
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Principal</h4>
          </CardHeader>
          <CardBody>
            <TextField
              disabled
              label="Código SAP"
              name="ItemCode"
              value={dataProduct.ItemCode || ''}
              inputProps={{ onChange: inputChange }}
              fullWidth
              margin="normal"
              size="small"
            />
            <TextField
              label="Código externo"
              name="FrgnName"
              value={dataProduct.FrgnName || ''}
              inputProps={{ onChange: inputChange }}
              fullWidth
              margin="normal"
              size="small"
            />
            <TextField
              label="Código externo 2"
              name="FrgnName2"
              value={dataProduct.FrgnName2 || ''}
              inputProps={{ onChange: inputChange }}
              fullWidth
              margin="normal"
              size="small"
            />
            <TextField
              label="Producto de origen"
              name="logi_product_origin_id"
              value={dataProduct.logi_product_origin_name || ''}
              inputProps={{ onChange: inputChange }}
              margin="normal"
              InputProps={{
                startAdornment: (
                  <InputAdornment
                    style={{ cursor: 'pointer', color: '#07c107' }}
                    onClick={() => setOpenModalProduct(true)}
                    position="start"
                  >
                    <Search />
                  </InputAdornment>
                )
              }}
              fullWidth
            />
            
            {/* <TextField
              label="Código de origen"
              name="logi_product_origin_id"
              value={dataProduct.logi_product_origin_id || ''}
              inputProps={{ onChange: inputChange }}
              fullWidth
              margin="normal"
              size="small"
            /> */}
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Proveedor</InputLabel>
              <Select
                value={dataProduct.base_business_partner_id || ''}
                inputProps={{
                  name: 'base_business_partner_id',
                  onChange: inputChange,
                }}
              >
                {providers.map((item) => {
                  return (
                    <MenuItem key={item.id} value={item.id}>
                      {item.CardName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <TextField
              name="ItemName"
              label="Nombre de artículo"
              value={dataProduct.ItemName || ''}
              inputProps={{ onChange: inputChange }}
              fullWidth
              margin="normal"
              size="small"
            />
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Tipo de artículo</InputLabel>
              <Select
                value={dataProduct.ItemType || ''}
                inputProps={{
                  name: 'ItemType',
                  onChange: inputChange,
                }}
              >
                {articleTypes.map((item) => {
                  return (
                    <MenuItem key={item.value} value={item.value}>
                      {item.description}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Bonificación</InputLabel>
              <Select
                value={dataProduct.QryGroup1 || 'N'}
                inputProps={{
                  name: 'QryGroup1',
                  onChange: inputChange,
                }}
              >
                <MenuItem value="Y">Si</MenuItem>
                <MenuItem value="N">No</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth margin="normal" size="small">
              <InputLabel>Estado</InputLabel>
              <Select
                value={dataProduct.state || ''}
                inputProps={{
                  name: 'state',
                  onChange: inputChange,
                }}
              >
                <MenuItem value="A">Activo</MenuItem>
                <MenuItem value="I">Inactivo</MenuItem>
              </Select>
            </FormControl>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} sm={12} md={8}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader icon>
                <CardIcon color="primary">
                  <Assignment />
                </CardIcon>
                <h4 style={{ color: 'black' }}>Categorías</h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} md={4}>
                    <TextField
                      name="U_SYP_MODELO"
                      label="Modelo"
                      defaultValue={dataProduct.U_SYP_MODELO || ''}
                      fullWidth
                      inputProps={{ onChange: inputChange }}
                      margin="normal"
                      size="small"
                    />
                  </GridItem>
                  <GridItem xs={12} md={4}>
                    <FormControl fullWidth margin="normal" size="small">
                      <InputLabel>Categoría</InputLabel>
                      <Select
                        value={dataProduct.logi_category_id || ''}
                        inputProps={{
                          name: 'logi_category_id',
                          onChange: inputChange,
                        }}
                      >
                        {categories.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.description}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} md={4}>
                    <FormControl fullWidth margin="normal" size="small">
                      <InputLabel>Línea</InputLabel>
                      <Select
                        value={dataProduct.logi_line_id || ''}
                        inputProps={{
                          name: 'logi_line_id',
                          onChange: inputChange,
                        }}
                      >
                        {lines.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.description}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} md={4}>
                    <FormControl fullWidth margin="normal" size="small">
                      <InputLabel>Familia</InputLabel>
                      <Select
                        value={dataProduct.logi_family_id || ''}
                        inputProps={{
                          name: 'logi_family_id',
                          onChange: inputChange,
                        }}
                      >
                        {families.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.description}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} md={4}>
                    <FormControl fullWidth margin="normal" size="small">
                      <InputLabel>SubFamilia</InputLabel>
                      <Select
                        value={dataProduct.logi_sub_family_id || ''}
                        inputProps={{
                          name: 'logi_sub_family_id',
                          onChange: inputChange,
                        }}
                      >
                        {subfamilies.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.description}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} md={4}>
                    <FormControl fullWidth margin="normal" size="small">
                      <InputLabel>Marca</InputLabel>
                      <Select
                        value={dataProduct.logi_mark_id || ''}
                        inputProps={{
                          name: 'logi_mark_id',
                          onChange: inputChange,
                        }}
                      >
                        {marks.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.description}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader icon>
                    <CardIcon color="primary">
                      <Assignment />
                    </CardIcon>
                    <h4 style={{ color: 'black' }}>Grupo</h4>
                  </CardHeader>
                  <CardBody>
                    <FormControl fullWidth margin="normal">
                      <InputLabel>Grupo de artículos</InputLabel>
                      <Select
                        value={dataProduct.logi_product_group_id || ''}
                        inputProps={{
                          name: 'logi_product_group_id',
                          onChange: inputChange,
                        }}
                      >
                        {itemGroups.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.ItmsGrpNam}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                      <InputLabel>Grupo unid. de medida</InputLabel>
                      <Select
                        value={dataProduct.logi_measure_unit_id_UgpEntry || ''}
                        inputProps={{
                          name: 'logi_measure_unit_id_UgpEntry',
                          onChange: inputChange,
                        }}
                      >
                        {measureUnitTypes.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.UgpName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                      <InputLabel>Lista de Precio</InputLabel>
                      <Select
                        value={dataProduct.logi_price_list_id || ''}
                        inputProps={{
                          name: 'logi_price_list_id',
                          onChange: inputChange,
                        }}
                      >
                        {priceLists.map((item) => (
                          <MenuItem key={item.id} value={item.id}>
                            {item.ListName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {dataProduct?.CardCode === 'P20255172884' ? (
                      <FormControl fullWidth margin="normal">
                        <InputLabel>Grupo para reporte diario</InputLabel>
                        <Select
                          value={dataProduct.group[0]?.group_description || ''}
                          onChange={(e) => {
                            const value = e.target.value;
                            setDataProduct((prev) => ({
                              ...prev,
                              group:
                                prev.group.length > 0
                                  ? prev.group.map((g, i) =>
                                      i === 0 ? { ...g, group_description: value } : g
                                    )
                                  : [
                                      {
                                        group_description: value,
                                      },
                                    ],
                            }));
                          }}
                        >
                          <MenuItem value="Tena">Tena</MenuItem>
                          <MenuItem value="Pequeñin">Pequeñin</MenuItem>
                          <MenuItem value="Nosotras">Nosotras</MenuItem>
                        </Select>
                      </FormControl>
                    ) : null}
                  </CardBody>
                </Card>
              </GridItem>
              <GridItem xs={12} sm={12} md={6}>
                <Card>
                  <CardHeader icon>
                    <CardIcon color="primary">
                      <Assignment />
                    </CardIcon>
                    <h4 style={{ color: 'black' }}>Otros</h4>
                  </CardHeader>
                  <CardBody>
                    <TextField
                      name="CodeBars"
                      label="Codigo de Barras"
                      defaultValue={dataProduct.CodeBars || ''}
                      inputProps={{ onChange: inputChange }}
                      fullWidth
                      margin="normal"
                    />
                    <FormControl fullWidth margin="normal">
                      <InputLabel>Compra</InputLabel>
                      <Select
                        value={dataProduct.PrchseItem || ''}
                        inputProps={{
                          name: 'PrchseItem',
                          onChange: inputChange,
                        }}
                      >
                        <MenuItem value="Y">Si</MenuItem>
                        <MenuItem value="N">No</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                      <InputLabel>Venta</InputLabel>
                      <Select
                        value={dataProduct.SellItem || ''}
                        inputProps={{
                          name: 'SellItem',
                          onChange: inputChange,
                        }}
                      >
                        <MenuItem value="Y">Si</MenuItem>
                        <MenuItem value="N">No</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl fullWidth margin="normal">
                      <InputLabel>Listado en venta</InputLabel>
                      <Select
                        disabled={dataProduct.SellItem === 'N'}
                        value={dataProduct.disable_sales_listing === true || dataProduct.disable_sales_listing === '1' ? '1' : '0'}
                        inputProps={{
                          name: 'disable_sales_listing',
                          onChange: inputChange,
                        }}
                      >
                        <MenuItem value="0">Si</MenuItem>
                        <MenuItem value="1">No</MenuItem>
                      </Select>
                    </FormControl>
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </GridItem>
    </>
  );
}
